
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/hooks/useAuth';
import { Heart, MapPin, Calendar, Trash2, Compass } from 'lucide-react';
import { useState } from 'react';
import LoginPrompt from '@/components/shared/LoginPrompt';

const tabs = ['全部', '行程', '日记', '游记', '攻略', '景点'];

const collections = [
  { id: 1, type: '行程', title: '大理5日游', days: 5, budget: '3000', img: 'dali' },
  { id: 2, type: '游记', title: '西藏朝圣之路', author: '山野行者', likes: 620, img: 'tibet' },
  { id: 3, type: '景点', name: '故宫博物院', rating: 4.9, category: '5A景区', img: 'forbidden,city' },
];

const MyCollections = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('全部');

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-bg-primary text-text-secondary">加载中...</div>;

  if (!user) {
    return (
      <div className="min-h-screen bg-bg-primary">
        <Navbar />
        <div className="pt-28 pb-20">
          <LoginPrompt title="我的收藏" description="登录后管理你的行程、游记与景点收藏" />
        </div>
      </div>
    );
  }

  const filtered = activeTab === '全部' ? collections : collections.filter((c) => c.type === activeTab);

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold text-text-primary">我的收藏</h1>
            <p className="text-text-secondary mt-1">共 {collections.length} 个收藏</p>
          </div>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mb-6">
          <TabsList className="bg-white rounded-btn p-1 shadow-card">
            {tabs.map((t) => <TabsTrigger key={t} value={t} className="rounded-btn px-4 data-[state=active]:bg-primary data-[state=active]:text-white">{t}</TabsTrigger>)}
          </TabsList>
        </Tabs>

        {filtered.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-16 h-16 text-text-tertiary opacity-40 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-text-primary mb-2">还没有任何收藏</h3>
            <Button onClick={() => navigate('/guides')} className="bg-primary hover:bg-primary-hover text-white rounded-btn mt-4">去发现</Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((item) => (
              <Card key={item.id} className="border-0 shadow-card rounded-card bg-white overflow-hidden group">
                <div className="h-40 bg-bg-secondary relative">
                  <img src={`https://picsum.photos/seed/${item.img}/600/400`} alt="" className="w-full h-full mx-auto object-cover" />
                  <button onClick={() => {}} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-danger"><Trash2 className="w-4 h-4" /></button>
                </div>
                <CardContent className="p-4">
                  {item.type === '行程' && (
                    <>
                      <h3 className="font-semibold text-text-primary mb-2">{item.title}</h3>
                      <div className="flex items-center gap-3 text-xs text-text-tertiary">
                        <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {item.days}天</span>
                        <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {item.budget}</span>
                      </div>
                    </>
                  )}
                  {item.type === '游记' && (
                    <>
                      <h3 className="font-semibold text-text-primary mb-2">{item.title}</h3>
                      <p className="text-xs text-text-secondary mb-1">{item.author}</p>
                      <p className="text-xs text-text-tertiary flex items-center gap-1"><Heart className="w-3 h-3" /> {item.likes}</p>
                    </>
                  )}
                  {item.type === '景点' && (
                    <>
                      <h3 className="font-semibold text-text-primary mb-2">{item.name}</h3>
                      <div className="flex items-center gap-2">
                        <span className="text-primary text-xs">{'★'.repeat(Math.floor(item.rating))}</span>
                        <Badge className="bg-primary-light text-primary rounded-full text-[10px]">{item.category}</Badge>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyCollections;

